module.exports = __webpack_public_path__ + "static/img/nav15.ccb96fa1.svg";